// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import AnimeController from "./anime_controller"
application.register("anime", AnimeController)

import StaggerCardsController from "./stagger_cards_controller"
application.register("stagger-cards", StaggerCardsController)

import SecurityMarkController from "./security_mark_controller"
application.register("security-mark", SecurityMarkController)

// ## Dae20 script #################################
import Dae20StaticGridDragController from "./dae20/static_grid_drag_controller"
application.register("dae20--static-grid-drag", Dae20StaticGridDragController)

import Dae20ComponentLoaderController from "./dae20/component_loader_controller"
application.register("dae20--component-loader", Dae20ComponentLoaderController)

import Dae20PreviewController from "./dae20/preview_controller"
application.register("dae20--preview", Dae20PreviewController)

// Старая плоская карта импорта заменена source-first деревом (см. ниже).
// Файл workspace_import_map_controller.js оставлен на диске до финальной проверки.
// import Dae20WorkspaceImportMapController from "./dae20/workspace_import_map_controller"
// application.register("dae20--workspace-import-map", Dae20WorkspaceImportMapController)

import Dae20WorkspaceExportMapController from "./dae20/workspace_export_map_controller"
application.register("dae20--workspace-export-map", Dae20WorkspaceExportMapController)

import Dae20WorkspaceExportTreeController from "./dae20/workspace_export_tree_controller"
application.register("dae20--workspace-export-tree", Dae20WorkspaceExportTreeController)

import Dae20WorkspaceImportTreeController from "./dae20/workspace_import_tree_controller"
application.register("dae20--workspace-import-tree", Dae20WorkspaceImportTreeController)

import Dae20ComponentTemplatePreviewController from "./dae20/component_template_preview_controller"
application.register("template-preview-dae20", Dae20ComponentTemplatePreviewController)

import Dae20PageNavController from "./dae20/page_nav_controller"
application.register("dae20--page-nav", Dae20PageNavController)

import Dae20ModalFormController from "./dae20/modal_form_controller"
application.register("dae20--modal-form", Dae20ModalFormController)

import Dae20LiveTableController from "./dae20/live_table_controller"
application.register("dae20--live-table", Dae20LiveTableController)

import Dae20RegisterOrderFormController from "./dae20/register_order_form_controller"
application.register("dae20--register-order-form", Dae20RegisterOrderFormController)

import Dae20RegisterDropFormController from "./dae20/register_drop_form_controller"
application.register("dae20--register-drop-form", Dae20RegisterDropFormController)

import Dae20FileUploadPreviewController from "./dae20/file_upload_preview_controller"
application.register("dae20--file-upload-preview", Dae20FileUploadPreviewController)

import Dae20FilterController from "./dae20/filter_controller"
application.register("dae20--filter", Dae20FilterController)

import Dae20LlmSettingsController from "./dae20/llm_settings_controller"
application.register("dae20--llm-settings", Dae20LlmSettingsController)

import Dae20SearchableListController from "./dae20/searchable_list_controller"
application.register("dae20--searchable-list", Dae20SearchableListController)

import Dae20ChartController from "./dae20/chart_controller"
application.register("dae20--chart", Dae20ChartController)

import Dae20RatingSettingsController from "./dae20/rating_settings_controller"
application.register("dae20--rating-settings", Dae20RatingSettingsController)

import Dae20KanbanController from "./dae20/kanban_controller"
application.register("dae20--kanban", Dae20KanbanController)

import Dae20LiveKanbanController from "./dae20/live_kanban_controller"
application.register("dae20--live-kanban", Dae20LiveKanbanController)

import Dae20LiveBlockController from "./dae20/live_block_controller"
application.register("dae20--live-block", Dae20LiveBlockController)

import Dae20OfferCountdownController from "./dae20/offer_countdown_controller"
application.register("dae20--offer-countdown", Dae20OfferCountdownController)

import Dae20ChatScrollController from "./dae20/chat_scroll_controller"
application.register("dae20--chat-scroll", Dae20ChatScrollController)

import Dae20ChatFilterController from "./dae20/chat_filter_controller"
application.register("dae20--chat-filter", Dae20ChatFilterController)

import Dae20ChatPendingController from "./dae20/chat_pending_controller"
application.register("dae20--chat-pending", Dae20ChatPendingController)

import Dae20ChatLinkPatcherController from "./dae20/chat_link_patcher_controller"
application.register("dae20--chat-link-patcher", Dae20ChatLinkPatcherController)

import Dae20ModalTabsController from "./dae20/modal_tabs_controller"
application.register("dae20--modal-tabs", Dae20ModalTabsController)

import Dae20FormListRowController from "./dae20/form_list_row_controller"
application.register("dae20--form-list-row", Dae20FormListRowController)

import Dae20FormListNewRowController from "./dae20/form_list_new_row_controller"
application.register("dae20--form-list-new-row", Dae20FormListNewRowController)

import Dae20WidgetLoaderController from "./dae20/widget_loader_controller"
application.register("dae20--widget-loader", Dae20WidgetLoaderController)

import Dae20SourceFiltersController from "./dae20/source_filters_controller"
application.register("dae20--source-filters", Dae20SourceFiltersController)

import Dae20FiltersRowsController from "./dae20/filters_rows_controller"
application.register("dae20--filters-rows", Dae20FiltersRowsController)

import Dae20CopySuggestionsController from "./dae20/copy_suggestions_controller"
application.register("dae20--copy-suggestions", Dae20CopySuggestionsController)

import Dae20AutocompleteController from "./dae20/autocomplete_controller"
application.register("dae20--autocomplete", Dae20AutocompleteController)

import Dae20PipelineController from "./dae20/pipeline_controller"
application.register("dae20--pipeline", Dae20PipelineController)

import Dae20TableGroupController from "./dae20/table_group_controller"
application.register("dae20--table-group", Dae20TableGroupController)

import Dae20TmcSnapshotController from "./dae20/tmc_snapshot_controller"
application.register("dae20--tmc-snapshot", Dae20TmcSnapshotController)

import Dae20TmcMonitorController from "./dae20/tmc_monitor_controller"
application.register("dae20--tmc-monitor", Dae20TmcMonitorController)

import Dae20RunTaskNowController from "./dae20/run_task_now_controller"
application.register("dae20--run-task-now", Dae20RunTaskNowController)

import Dae20TagsInputController from "./dae20/tags_input_controller"
application.register("dae20--tags-input", Dae20TagsInputController)

import Dae20ChecklistController from "./dae20/checklist_controller"
application.register("dae20--checklist", Dae20ChecklistController)

import Dae20ButtonGroupController from "./dae20/button_group_controller"
application.register("dae20--button-group", Dae20ButtonGroupController)

import Dae20SlimSearchController from "./dae20/slim_search_controller"
application.register("dae20--slim-search", Dae20SlimSearchController)

import Dae20ApiKeyRevealController from "./dae20/api_key_reveal_controller"
application.register("dae20--api-key-reveal", Dae20ApiKeyRevealController)

import Dae20WorkspaceSharingController from "./dae20/workspace_sharing_controller"
application.register("dae20--workspace-sharing", Dae20WorkspaceSharingController)

import Dae20UserTableEditorController from "./dae20/user_table_editor_controller"
application.register("dae20--user-table-editor", Dae20UserTableEditorController)


import Dae20TemplatePickerController from "./dae20/template_picker_controller"
application.register("template-picker", Dae20TemplatePickerController)

import Dae20EditorPickersController from "./dae20/editor_pickers_controller"
application.register("editor-pickers", Dae20EditorPickersController)

import Dae20ClickOutsideController from "./dae20/click_outside_controller"
application.register("dae20--click-outside", Dae20ClickOutsideController)

import Dae20SourcesViewToggleController from "./dae20/sources_view_toggle_controller"
application.register("dae20--sources-view-toggle", Dae20SourcesViewToggleController)

import Dae20ItemTemplatesViewToggleController from "./dae20/item_templates_view_toggle_controller"
application.register("dae20--item-templates-view-toggle", Dae20ItemTemplatesViewToggleController)

// ## Ai-chat  script
import ChatFormController from "./ai_chat/chat_form_controller"
application.register("chat-form", ChatFormController)

// ## P220 AI Chat
import P220ChatWidgetController from "./p220/chat_widget_controller"
application.register("p220--chat-widget", P220ChatWidgetController)

import P220ChatFormController from "./p220/chat_form_controller"
application.register("p220--chat-form", P220ChatFormController)

// ## P2P script
import P2PCardMaskController from "./p2p/card_mask_controller"
application.register("card-mask", P2PCardMaskController)

import ModerActionsController from "./moder_actions_controller"
application.register("moder-actions", ModerActionsController)

import PaymentMethodToggleController from "./p2p/payment_method_toggle_controller"
application.register("payment-method-toggle", PaymentMethodToggleController)

import PhoneMaskController from "./p2p/phone_mask_controller"
application.register("phone-mask", PhoneMaskController)

import P2PSubmitButtonController from "./p2p/submit_button_controller"
application.register("p2p--submit-button", P2PSubmitButtonController)

import P2PLoginSanitizeController from "./p2p/login_sanitize_controller"
application.register("p2p--login-sanitize", P2PLoginSanitizeController)

import P2PConfirmModalController from "./p2p/confirm_modal_controller"
application.register("p2p--confirm-modal", P2PConfirmModalController)
import P220MobileRedirectController from "./p220/mobile_redirect_controller"
application.register("p220--mobile-redirect", P220MobileRedirectController)

import P220MobileHeaderMenuController from "./p220/mobile_header_menu_controller"
application.register("p220--mobile-header-menu", P220MobileHeaderMenuController)

// ## P220 Constructor (page builder sidesheet)
import P220ConstructorController from "./p220/constructor_controller"
application.register("p220--constructor", P220ConstructorController)

// ## P220 Page Picker (modal)
import P220PagePickerController from "./p220/page_picker_controller"
application.register("p220--page-picker", P220PagePickerController)

import P220QrLoginController from "./p220/qr_login_controller"
application.register("p220--qr-login", P220QrLoginController)

// ## P220 Table Pagination (spinner on arrows + overlay)
import P220TablePaginationController from "./p220/table_pagination_controller"
application.register("p220--table-pagination", P220TablePaginationController)

// ## Workspace Search (live filter)
import WorkspaceSearchController from "./workspace_search_controller"
application.register("workspace-search", WorkspaceSearchController)

// ## Special script

import GmenuController from "./special/gmenu_controller"
application.register("gmenu", GmenuController)
import NestedFormController from "./special/nested_form_controller"
application.register("nested-form", NestedFormController)
import SourceTypeController from "./special/source_type_controller"
application.register("source_type", SourceTypeController)
import KanbanController from "./special/kanban_controller"
application.register("kanban", KanbanController)
// Загрузка данных источника
import SourceInspectorController from "./special/source_inspector_controller"
application.register("source-inspector", SourceInspectorController)

// ## Default script
import ConfirmController from "./default/confirm_controller"
application.register("confirm", ConfirmController)

import HeroImageController from "./default/hero_image_controller"
application.register("hero-image", HeroImageController)

import ScrollToController from "./default/scroll_to_controller"
application.register("scroll-to", ScrollToController)

import ScrollToTopController from "./default/scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import TextToggleController from "./default/text_toggle_controller"
application.register("text-toggle", TextToggleController)

import ToggleFilterController from "./default/toggle_filter_controller"
application.register("toggle-filter", ToggleFilterController)

import ZoomController from "./default/zoom_controller"
application.register("zoom", ZoomController)

import AvatarPreviewController from "./default/avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

// ## RS_SCRIPT

import ClipboardController from "./rs_script/clipboard_controller"
application.register("clipboard", ClipboardController)

import ListAssociationController from "./rs_script/list_association_controller"
application.register("list-association", ListAssociationController)

import MmenuController from "./rs_script/mmenu_controller"
application.register("mmenu", MmenuController)

import QuillController from "./rs_script/quill_controller"
application.register("quill", QuillController)

import ShowController from "./rs_script/show_controller"
application.register("show", ShowController)

import SlimController from "./rs_script/slim_controller"
application.register("slim", SlimController)

import StickyController from "./rs_script/sticky_controller"
application.register("sticky", StickyController)

import SettingValueController from "./rs_script/setting_value_controller"
application.register("setting-value", SettingValueController)

import TurboReloadController from "./rs_script/turbo_reload_controller"
application.register("turbo-reload", TurboReloadController)

import AutoHideController from "./rs_script/auto_hide_controller"
application.register("auto-hide", AutoHideController)

import MoneyInputController from "./rs_script/money_input_controller"
application.register("money-input", MoneyInputController)



// import AccordionController from "../../../vendor/javascript/controller/accordion_controller"
// application.register("accordion", AccordionController)

// import AosController from "../../../vendor/javascript/controller/aos_controller"
// application.register("aos", AosController)

// import MapController from "../../../vendor/javascript/controller/map_controller"
// application.register("map", MapController)

// import MetaController from "../../../vendor/javascript/controller/meta_controller"
// application.register("meta", MetaController)

// import ParallaxController from "../../../vendor/javascript/controller/parallax_controller"
// application.register("parallax", ParallaxController)

// import SettingValueController from "../../../vendor/javascript/controller/setting_value_controller"
// application.register("setting-value", SettingValueController)

// import HoverController from "../../../vendor/javascript/controller/hover_controller"
// application.register("hover", HoverController)

import LightboxController from "../../../vendor/javascript/controller/lightbox_controller"
application.register("lightbox", LightboxController)
